import axios from 'axios';

// 1. Cria uma instância do Axios com a URL base da API
// Para projetos create-react-app, a variável de ambiente deve começar com REACT_APP_
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api',
});

// 2. Cria um "interceptor" para adicionar o token de autenticação em todas as requisições
// Isso é executado ANTES de cada chamada à API.
apiClient.interceptors.request.use(
    (config) => {
        // Pega o token do localStorage, que é onde o AuthContext o armazena
        const token = localStorage.getItem('token');
        
        // Se o token existir, adiciona ao cabeçalho de autorização no formato Bearer
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        return config;
    },
    (error) => {
        // Em caso de erro na configuração da requisição, rejeita a promise
        return Promise.reject(error);
    }
);

export default apiClient;
